export default __webpack_public_path__ + "static/media/change_circle_black_24dp.f504848e.svg";